export const Items = {
  start: [
    {
      key: "components-start",
      label: "Components",
      noActive: true,
      display: false
    },
    {
      key: "features-accuracy",
      label: "Features and Benefits",
      noActive: true,
      display: false
    },
    {
      key: "workflow-preparation",
      label: "Workflow",
      noActive: true,
      display: false
    },
    {
      key: "contact",
      label: "Contact",
      noActive: true,
      display: false
    }
  ],
  components: [
    {
      key: "start",
      label: "",
      startFrame: 0,
      frames: 0,
      display: false,
      classNames: "scale-12",
      tips: [
        {
          left: "22%",
          top: "90%",
          text: "Nanoplate & Plate Sealer",
          goTo: "#components-nanoplate"
        },
        {
          left: "75%",
          top: "72%",
          text: "On Board Touch Screen",
          goTo: "#components-touchscreen"
        },
        {
          left: "89%",
          top: "40%",
          text: "Puncher and Roller",
          goTo: "#components-puncher"
        },
        {
          left: "81%",
          top: "27%",
          text: "Barcode Scanner",
          goTo: "#components-barcode"
        },
        {
          left: "58%",
          top: "48%",
          text: "Optical Module",
          goTo: "#components-optical"
        },
        {
          left: "63%",
          top: "36%",
          text: "Tray",
          goTo: "#components-tray"
        },
        {
          left: "74%",
          top: "46%",
          text: "Thermocycler",
          goTo: "#components-thermocycler"
        },
        {
          left: "16%",
          top: "16%",
          text: "Software Suite",
          goTo: "#components-software"
        }
      ]
    },
    {
      key: "nanoplate",
      label: "Nanoplate & Plate Sealer",
      startFrame: 3,
      frames: 72,
      classNames: "scale-12",
      // texts: [
      //   {
      //     title: "Nanoplate",
      //     desc: "Pipette your reaction mixture here in single wells",
      //     left: "10%",
      //     top: "-50px"
      //   },
      //   {
      //     title: "On Board Touch Screen",
      //     desc: "Rubber seal for secure plate sealing",
      //     left: "40%",
      //     top: "90%"
      //   }
      // ],
      tips: [
        {
          left: "22%",
          top: "54%",
          text:
            "<b>Nanoplate</b><br />Pipette your reaction mixture here in single wells. Depending on the nanoplate configuration used, one can achieve the required partitioning."
        },
        {
          left: "55%",
          top: "28%",
          text:
            "<b>Plate sealer</b><br />Rubber seal for secure plate sealing and to avoid contamination"
        }
      ]
    },
    {
      key: "touchscreen",
      label: "On Board Touch Screen",
      startFrame: 150,
      frames: 187,
      classNames: "scale-15",
      // texts: [
      //   {
      //     title: "On board touch screen",
      //     desc: "Allows simple, intuitive run setup",
      //     left: "10%",
      //     top: "80%"
      //   }
      // ],
      tips: [
        {
          left: "56%",
          top: "53%",
          text:
            "<b>On board touch screen</b><br />Allows simple, intuitive run setup"
        }
      ]
    },
    {
      key: "puncher",
      label: "Puncher and Roller",
      startFrame: 293,
      frames: 319,
      classNames: "scale-15",
      tips: [
        {
          left: "60%",
          top: "31%",
          text:
            "<b>Puncher and Roller</b><br />Puncher pushes the reaction mixture in the wells through the partitions, also termed as priming. Roller compresses the bottom seal and seals partitions individually, also termed as rolling."
        }
      ]
      // texts: [
      //   {
      //     title: "Puncher and Roller",
      //     width: "80%",
      //     desc:
      //       "Puncher pushes the reaction mixture in the wells through the partitions, also termed as priming. Roller compresses the bottom seal and seals partitions individually, also termed as rolling.",
      //     left: "10%",
      //     top: "80%"
      //   }
      // ]
    },
    {
      key: "barcode",
      label: "Barcode Scanner",
      startFrame: 343,
      frames: 361,
      classNames: "scale-15",
      tips: [
        {
          left: "48%",
          top: "28%",
          text:
            "<b>Barcode Scanner</b><br />Reads the barcode on the plate to ensure running the correct plate and having full process control"
        }
      ]
      // texts: [
      //   {
      //     title: "Barcode Scanner",
      //     desc: "Reads the barcode on the plate",
      //     left: "10%",
      //     top: "80%"
      //   }
      // ]
    },
    {
      key: "optical",
      label: "Optical Module",
      classNames: "scale-15",
      startFrame: 515,
      frames: 550,
      tips: [
        {
          left: "50%",
          top: "37%",
          text:
            "<b>Optical Module</b><br />Captures fluorescence images of the plate using multi-color detection optics or multi-channel filters"
        }
      ]
      // texts: [
      //   {
      //     title: "Optical Module",
      //     desc:
      //       "Captures fluorescence images of the plate using multi-color detection optics or multi-channel filters",
      //     left: "10%",
      //     top: "80%",
      //     width: "50%"
      //   }
      // ]
    },
    {
      key: "tray",
      label: "Tray",
      startFrame: 645,
      frames: 718,
      classNames: "scale-15",
      tips: [
        {
          left: "50%",
          top: "25%",
          text:
            "<b>Tray</b><br />Load one or more nanoplates here depending on the instrument configuration"
        }
      ]
      // texts: [
      //   {
      //     title: "Tray",
      //     desc: "Load one or more nanoplates here",
      //     left: "10%",
      //     top: "80%"
      //   }
      // ]
    },
    {
      key: "thermocycler",
      label: "Thermocycler",
      classNames: "scale-15",
      startFrame: 800,
      frames: 849,
      tips: [
        {
          left: "55%",
          top: "28%",
          text:
            "<b>Thermocycler</b><br />Performs amplification reaction by pre-programmed temperature and time variation"
        }
      ]
      // texts: [
      //   {
      //     title: "Thermocycler",
      //     desc:
      //       "Performs amplification reaction by pre-programmed temperature and time variation",
      //     left: "10%",
      //     top: "80%"
      //   }
      // ]
    },
    {
      key: "software",
      label: "Software Suite",
      classNames: "scale-12",
      startFrame: 900,
      frames: 948,
      tips: [
        {
          left: "16%",
          top: "17%",
          text:
            "<b>Software Suite</b><br />A combined dPCR run setup and analysis software that allows you to access, design and analyze experiments from anywhere"
        }
      ]
      // texts: [
      //   {
      //     title: "Software Suite",
      //     desc:
      //       "A combined dPCR run setup and analysis software that allows you to access, design and analyze experiments from anywhere",
      //     left: "10%",
      //     top: "95%"
      //   }
      // ]
    }
  ],
  features: [
    {
      key: "accuracy",
      label: "Accuracy & Sensitivity",
      classNames: "scale-12",
      startFrame: 0,
      frames: 0,
      tips: [
        {
          left: "5%",
          top: "73%",
          text:
            "24-well × approx. 26,000 partitions<br />Input volume/well 40 μl"
        },
        {
          left: "43%",
          top: "62%",
          text:
            "24-well × approx. 8,500 partitions<br />Input volume/well 12 μl"
        },
        {
          left: "73%",
          top: "53%",
          text:
            "96-well × approx. 8,500 partitions<br />Input volume/well 12 μl"
        }
      ]
      // texts: [
      //   {
      //     title: "24-well × approx. 26,000 partitions",
      //     left: "10%",
      //     top: "90%"
      //   },
      //   {
      //     title: "24-well × approx. 26,000 partitions",
      //     left: "35%",
      //     top: "80%"
      //   },
      //   {
      //     title: "24-well × approx. 26,000 partitions",
      //     left: "65%",
      //     top: "70%"
      //   }
      // ]
    },
    {
      key: "accuracyBack",
      classNames: "scale-12",
      display: false,
      startFrame: 25,
      frames: 44
    },
    {
      key: "scalability",
      label: "Scalability",
      startFrame: 52,
      frames: 87,
      texts: [
        {
          title:
            "Low- to high-throughput instrument configurations – 1-, 4- and 8-plate<br />Up to 2 integrated thermocyclers",
          left: "10%",
          top: "80%"
        }
      ]
    },
    {
      key: "throughput",
      label: "Throughput",
      classNames: "scale-12",
      startFrame: 105,
      frames: 260,
      texts: [
        {
          title:
            "Under 2 hours – up to 96 samples (first plate)<br />Every ~30 minutes a following plate<br />Samples processed in a work day – up to 1248 (96-well) and up to 312 (24-well), if using the 8-plate instrument",
          left: "10%",
          top: "88%"
        }
      ]
    },
    {
      key: "multiplexing",
      label: "Multiplexing",
      startFrame: 323,
      frames: 373,
      texts: [
        {
          title:
            "Up to 5 detection channels<br />(2-plex and 5-plex; exclusive of reference)",
          left: "10%",
          top: "80%"
        }
      ]
    },
    {
      key: "remote",
      label: "Remote Analysis",
      startFrame: 380,
      frames: 456,
      texts: [
        {
          title: "Remote Analysis",
          desc: "Access, design and analyze from anywhere",
          left: "10%",
          top: "80%"
        }
      ]
    }
  ],
  workflow: [
    {
      key: "preparation",
      label: "Sample Preparation"
    },
    {
      key: "preparation_video",
      display: false
    },
    {
      key: "partitioning",
      label: "Partitioning, Thermocycling & Imaging"
    },
    {
      key: "partitioning_video",
      display: false
    },
    {
      key: "analysis",
      label: "Analysis of Results"
    },
    {
      key: "analysis_video",
      display: false
    }
  ],
  contact: []
};
